// Configuration for RemittanceLookup highlighting
export const remittanceHighlightConfig = {
  // User email to highlight in ArchivedBy field
  // When ArchivedBy matches this value, the archivedDate will be highlighted in yellow
  // To change the user, simply update the email address below
  highlightArchivedByUser: "NETRXARC",
};
